const AUTH_TOKEN_KEY = 'authToken';

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const decodeExpiry = (token) => {
    try {
        const [, payload] = token.split('.');
        if (!payload) return null;
        const parsed = JSON.parse(atob(payload));
        if (!parsed?.exp) return null;
        return parsed.exp * 1000;
    } catch (error) {
        return null;
    }
};

const readStoredData = () => {
    if (!isBrowser()) return null;
    const raw = window.localStorage.getItem(AUTH_TOKEN_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (error) {
        window.localStorage.removeItem(AUTH_TOKEN_KEY);
        return null;
    }
};

export const clearAuthToken = () => {
    if (!isBrowser()) return;
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const storeAuthToken = (token, rememberMe) => {
    if (!isBrowser()) return;
    const expiresAt = decodeExpiry(token);
    const payload = {
        token,
        rememberMe: Boolean(rememberMe),
        expiresAt,
        storedAt: Date.now(),
    };
    window.localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(payload));
};

export const getStoredTokenData = () => {
    const data = readStoredData();
    if (!data) return null;
    if (data.expiresAt && Date.now() > data.expiresAt) {
        clearAuthToken();
        return null;
    }
    if (!data.token) {
        clearAuthToken();
        return null;
    }
    return data;
};

export function getStoredToken() {
    const data = getStoredTokenData();
    return data?.token || null;
}

export function getAuthToken(tokenFromState) {
    if (tokenFromState) {
        return tokenFromState;
    }
    return getStoredToken();
}
